/**
 * Login Route
 *
 * Public authentication route with OAuth SSO support.
 * Delegates UI rendering to LoginPage from FSD pages layer.
 *
 * @see .agents/skills/molchanovs-move-docs-tasks/references/source/task-DOC-0051.md
 * @updated DOC-0099 (2025-12-26) - Use LoginPage from FSD pages layer
 */

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LoginPage } from '@pages/login';

/**
 * Query parameter schema for login page
 */
const loginSearchSchema = z.object({
  error: z.string().optional(),
  redirect: z.string().optional(),
});

export const Route = createFileRoute('/$locale/login')({
  component: LoginRoute,
  validateSearch: loginSearchSchema,
});

function LoginRoute() {
  const { locale } = Route.useParams();
  const search = Route.useSearch();

  return <LoginPage locale={locale} errorCode={search.error} redirectTo={search.redirect} />;
}
